module.exports = __webpack_public_path__ + "public/adminIcons/total-user.png?744d333e";